var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFavStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  fill: "none",
  stroke: "#AAA",
  strokeWidth: 1.24,
  d: "m12.6 7.3 5.9.8-4.3 4.2 1.1 5.9-5.3-2.9-5.3 2.8 1.1-5.8-4.3-4.2 5.9-.8L10 1.8l2.6 5.5z"
})));
export default SvgIconFavStroke;